<template>
    <div>
        <b-container class="py-3">
            <b-row>
                <b-col>

                    <b-alert v-if="isSessionExpired" class="text-center" show variant="warning">
                        Your session has expired. Please log in again.
                    </b-alert>

                    <page-title v-if="isAuthenticated" title="Log In" />
                    <div v-if="isAuthenticated">
                        <hr />
                        <p>You are already logged in as {{$root.$data.authenticatedUser.username}}.</p>
                    </div>
                    <auth-form v-if="!isAuthenticated" @authenticated="onAuthenticated" page="login" class="mt-3" />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import AuthMixin from '../Mixins/AuthMixin.vue';

export default {
      name: "Login",
      mixins: [AuthMixin],
      props: {},
      data() {
        return {
        }
      },
      methods: {
        onAuthenticated: function () {
          if (this.$route.query.redirect)
            this.$router.push(this.$route.query.redirect);
          else
            this.$router.push('/');
        }
        },
        computed: {
            isSessionExpired: function () {
                return !!(this.$route && this.$route.query && this.$route.query.expired);
            }
        },
      mounted () {
        this.refreshAuthenticationData();
        if (this.isAuthenticated) this.onAuthenticated();
      }
};
</script>